<template>
  <v-main class="d-flex v-application v-application v-application--is-ltr theme--light" style="height: calc(100vh - 56px)">
    <div data-app style="height: calc(100vh - 56px)">
      <v-dialog v-model="dialog" max-width="400" persistent>
        <v-card>
          <v-card-title class="headline">
            Schnittstellendatei ausgeben
          </v-card-title>

          <v-card-text>
            <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="date"
                persistent
                width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="formatedDate"
                    label="Leistungsmonat"
                    prepend-icon="mdi-calendar"
                    readonly
                    hide-details
                    v-bind="attrs"
                    class="mt-3"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="date"
                  :type="currentMode === 'M' ? 'month' : 'date'"
                  scrollable
                  locale="de"
                  :key="currentMode"
              >
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="primary"
                    @click="modal = false"
                >
                  Abbrechen
                </v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="setDate(date)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>

            <v-select
                v-model="selectedUsers"
                :items="this.mitasFlat"
                item-text="name"
                item-value="bis_id"
                label="Mitarbeiter"
                multiple
                outlined
                dense
                class="mt-4"

            >
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleSelectAll">
                  <v-list-item-action>
                    <v-icon :color="selectedUsers.length > 0 ? 'primary' : ''">
                      {{ selectAllIcon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Alle auswählen</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>

              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.name }}</span>
                <span v-if="index === 1" class="grey--text caption ml-2">
                (+{{ selectedUsers.length - 1 }} andere)
              </span>
              </template>
            </v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="submit" :disabled="!selectedUsers.length">Datei herunterladen</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-main>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import _orderBy from "lodash/orderBy"

import _ from 'lodash';


export default {
  name: "LohnInterface",
  components: {
  },
  data: () => ({
    // {text: "Quartal", value: "Q"}, {text: "halbes Jahr", value: "H"},
    dialog: false,
    dateModes: [{text: "Monat", value: "M"}, {text: "Quartal", value: "Q"}, {text: "halbes Jahr", value: "H"}, {text: "Jahr", value: "Y"}],
    currentMode: "M",
    monthsLong: ["","Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    quartals: [{text: "Q1", value: 1}, {text: "Q2", value: 2}, {text: "Q3", value: 3}, {text: "Q4", value: 4}],
    halfs: [{text: "H1", value: 1}, {text: "H2", value: 2}],
    currentQuartal: 1,
    currentHalf: 1,
    selectedUsers: [],
    users: [
      { id: 1, name: 'Alice Smith' },
      { id: 2, name: 'Bob Johnson' },
      { id: 3, name: 'Charlie Brown' },
      { id: 4, name: 'Diana Prince' },
      { id: 5, name: 'Evan Wright' }
    ],

    migrs: [],
    mitas: [],
    mitasFlat: [],
    activeMita:[],

    overlay: true,
    currentMita: [],
    userDays: [],

    search: '',
    date: new Date().toISOString().substr(0, 7),
    selectedDate: new Date().toISOString().substr(0, 10),
    modal: false,
    holliday_lohn: null,
    currentPdf: 'Bitte Auswahl treffen.pdf',
    lastClickedIndex: null,

  }),
  computed: {
    // True if all users are selected
    allUsersSelected() {
      return this.selectedUsers.length === this.users.length;
    },
    // True if some (but not all) users are selected
    someUsersSelected() {
      return this.selectedUsers.length > 0 && !this.allUsersSelected;
    },
    // Dynamically returns the correct icon based on selection state
    selectAllIcon() {
      if (this.allUsersSelected) return 'mdi-checkbox-marked';
      if (this.someUsersSelected) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
    formatedDate() {
      let splits = this.date.split("-");
      if (this.currentMode === 'M') {
        return this.monthsLong[parseInt(splits[1])] + ", " + splits[0]
      } else {
        return splits[0]
      }
    },
    filteredItems() {
      return _orderBy(this.mitasFlat.filter(item => {
        if(!this.search) return this.mitasFlat;
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      }), 'name');
    },
  },
  mounted () {
    //this.$parent.$emit('close-side-bar');
  },
  created() {
    this.showLoader();
    this.$http.get(
        Server_URL_ZK + '/zk/responsible_users'
    ).then(this.responseOkGet, this.responseError)
  },
  watch: {
  },
  methods: {
    toggleSelectAll() {
      this.$nextTick(() => {
        if (this.allUsersSelected) {
          // If all are selected, clear the array
          this.selectedUsers = [];
        } else {
          // Otherwise, select all user IDs
          this.selectedUsers = this.mitasFlat.map(user => user.bis_id);
        }
      });
    },
    submit() {
      let users = this.selectedUsers;
      let year = parseInt(this.selectedDate.split("-")[0]);
      let intervalValue = 0;
      switch (this.currentMode) {
        case 'M':
          intervalValue = parseInt(this.selectedDate.split("-")[1]);
          break;
      }
      this.showLoader();
      this.$http.post(
          Server_URL_ZK + '/zk/lohn_interface',
          {
            user_gischls: users,
            year: year,
            month: intervalValue,
          }, {responseType: 'blob'}
      ).then(this.responseOkTrap, this.responseError);
    },
    download() {
      setTimeout(() => {
        window.frames["print_frame"].focus();
        const a = document.createElement('a');
        a.href = this.currentPdf;
        a.download =  "Auswertung.pdf";
        a.style.position = 'fixed';
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },500);
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkGet(response) {
      this.hideLoader();
      this.dialog = true;
      if (response.status === 200) {
        for (let i = 0; i < response.body.migrs.length; i++) {
          this.activeMita.push(null);
        }
        this.migrs = response.body.migrs;
        this.mitas = response.body.mita;
        for (let migr in this.mitas) {
          for (let i = 0; i < this.mitas[migr].length; i++) {
            this.mitas[migr][i].name = this.getMitaNameForGischl(this.mitas[migr][i]);
          }
        }
        for (let i = 0; i < response.body.mita_flat.length; i++) {
          let mita = response.body.mita_flat[i];
          mita.name = this.getMitaNameForGischl(mita);
          this.mitasFlat.push(mita)
        }
        // order mitasFlat alphabetically
        this.mitasFlat = _orderBy(this.mitasFlat, 'name');

        this.holliday_lohn = response.body.holliday_lohn;
      } else {
        window.location = Redirect_500;
      }
    },
    async responseOkTrap(response) {
      this.hideLoader();
      if (response.status === 200) {
        let b = await response.blob();
        let filename = '';
        console.log(response.headers)
        try {
          filename = (response.headers['map']['content-disposition'][0] || '').split('filename=')[1];
          console.log(filename)
        } catch (e) {
          console.log(e)
        }
        let a = document.createElement('a');
        a.href = window.URL.createObjectURL(b);
        a.download = filename;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    setDate(date) {
      if (this.currentMode === 'M') {
        date = date + "-01";
      }
      this.date = date;
      this.$refs.dialog.save(date);
      this.selectedDate = date;
    },
    getMitaNameForGischl(mita) {
      if (mita === null) {
        return null;
      }
      let searchString = mita.bis_id
      if (!mita.bis_id.includes("-")) {
        searchString += "-"
      }
      let res = JSON.parse(sessionStorage.getItem(searchString));
      if (res === null) {
        return value;
      }
      return res.first_name + " " + res.surname;
    },
    getCurrentMita(id) {
      for (let i = 0; i < this.mitasFlat.length; i++) {
        if (this.mitasFlat[i].id === id) {
          return this.mitasFlat[i];
        }
      }
      return null;
    },
  }
}
</script>

<style scoped lang="scss">


/* Crucial for UX: Prevents ugly text highlighting during shift-click actions */
.disable-text-selection {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.v-list-item-group .v-list-item--active{
  background-color: #e4e5e6 !important;
}

::v-deep .v-list-item--link:before {
  background-color: transparent;
}

.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: '';
  }

  &:hover::after {
    display: block;
  }
}

.v-radio::v-deep {
  align-self: flex-start;
}

.v-input--is-disabled::v-deep input {
  color: black;
}

.v-radio::v-deep > .v-label {
  margin: 0;
}

::v-deep .saldo input {
  font-weight: 500;
}

::v-deep .pos input {
  color: green !important;
}

::v-deep .neg input {
  color: red !important;
}


::v-deep .v-list-item {
  min-height: 36px!important;
  padding: 0 8px!important;
}

::v-deep .v-list-item__content {
  padding: 8px 0!important;
}

</style>
